import { CSSResult, css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBackground, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const navigationMenuColumnStyle = {
  maxHeight: css`var(--csc-navigation-menu-column-max-height, 600px)`,
  padding: css`var(--csc-navigation-menu-column-padding, 0)`,
  backgroundColor: css`var(--csc-navigation-menu-column-background-color, ${csColorBackground.secondary})`,
  selectedBackgroundColor: css`var(--csc-navigation-menu-column-selected-background-color, ${csColorBackground.primary})`,
  fontSize: css`var(--csc-navigation-menu-column-font-size, 16px)`,
  fontWeight: css`var(--csc-navigation-menu-column-font-weight, 400)`,
  fontColor: css`var(--csc-navigation-menu-column-font-color, ${csColorText.body})`,
  fontSizeActive: css`var(--csc-navigation-menu-column-font-size-active, 16px)`,
  fontWeightActive: css`var(--csc-navigation-menu-column-font-weight-active, 400)`,
  fontColorActive: css`var(--csc-navigation-menu-column-font-color-active, ${csColorText.body})`,
  arrowIconColor: css`var(--csc-navigation-menu-column-arrow-icon-color, ${csColorText.body})`,
  arrowIconSize: css`var(--csc-navigation-menu-column-arrow-icon-size, 16px)`,
  titleColor: css`var(--csc-navigation-menu-column-title-color, ${csColorText.headings})`,
  titleFontWeight: css`var(--csc-navigation-menu-column-font-weight, 700)`,
  titleFontSize: css`var(--csc-navigation-menu-column-title-font-size, 16px)`,

  subLevelBackgroundColor: css`var(--csc-navigation-menu-column-sub-level-background-color, ${csColorBackground.primary})`,
  subLevelActiveBackgroundColor: css`var(--csc-navigation-menu-column-sub-level-active-background-color, ${csColorBackground.secondary})`,
  subLevelItemPadding: css`var(--csc-navigation-menu-column-sub-level-item-padding, ${csSpacing.spacing05})`,
  subLevelPaddingInline: css`var(--csc-navigation-menu-column-sub-level-padding-inline, ${csSpacing.spacing06})`,
}

export const style: CSSResult = css`
  :host {
    display: block;
    height: 100%;
  }

  .container {
    position: relative;
    max-height: ${navigationMenuColumnStyle.maxHeight};
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: ${navigationMenuColumnStyle.backgroundColor};
    padding: ${navigationMenuColumnStyle.padding};
  }

  .list {
    --cse-list-divider-gap: 0;

    flex-grow: 1;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding-bottom: ${csSpacing.spacing08};
    position: relative;
    -webkit-mask-image: linear-gradient(to bottom, black 0%, black calc(100% - ${csSpacing.spacing09}), transparent 100%);
    mask-image: linear-gradient(to bottom, black 0%, black calc(100% - ${csSpacing.spacing09}), transparent 100%);
    -webkit-mask-mode: alpha;
    mask-mode: alpha;
    transition: -webkit-mask-image 0.3s ease-in-out, mask-image 0.3s ease-in-out;
  }

  .list::-webkit-scrollbar {
    display: none;
  }

  .list:not(.show-gradient) {
    -webkit-mask-image: none;
    mask-image: none;
  }

  .title-item {
    padding: ${navigationMenuColumnStyle.subLevelItemPadding};
  }

  .all-products-link-item {
    padding: ${navigationMenuColumnStyle.subLevelItemPadding};
  }

  .title {
    --cs-font-body-font-weight: ${navigationMenuColumnStyle.titleFontWeight};
    --cse-text-color: ${navigationMenuColumnStyle.titleColor};
    --cs-font-body-font-size: ${navigationMenuColumnStyle.titleFontSize};
  }

  .nav-item {
    --cse-menu-item-background-color: transparent;
    --cse-menu-item-background-color-hover: ${navigationMenuColumnStyle.selectedBackgroundColor};
    --cse-menu-item-color-hover: ${csColorText.body};

    width: 100%;
  }

  .sub-level .nav-item {
    --cse-menu-item-background-color-hover: ${navigationMenuColumnStyle.subLevelActiveBackgroundColor};
    --cse-menu-item-background-color-selected: ${navigationMenuColumnStyle.subLevelActiveBackgroundColor};
  }

  .sub-level {
    background-color: ${navigationMenuColumnStyle.subLevelBackgroundColor};
    padding-inline: ${navigationMenuColumnStyle.subLevelPaddingInline};
  }

  .more-indicator {
    position: absolute;
    z-index: 10;
    bottom: ${csSpacing.spacing03};
    left: 50%;
    transform: translateX(-50%);
  }

  .more-indicator[hidden] {
    display: none;
  }

  .category-name {
    --cs-font-body-font-size: ${navigationMenuColumnStyle.fontSize};
    --cs-font-body-font-weight: ${navigationMenuColumnStyle.fontWeight};
    --cse-menu-item-color-hover: ${navigationMenuColumnStyle.fontColor};
  }

  .selected .category-name {
    --cs-font-body-font-size: ${navigationMenuColumnStyle.fontSizeActive};
    --cs-font-body-font-weight: ${navigationMenuColumnStyle.fontWeightActive};
    --cse-menu-item-color-hover: ${navigationMenuColumnStyle.fontColorActive};
  }

  .arrow-icon {
    --cse-icon-color: ${navigationMenuColumnStyle.arrowIconColor};
    --cse-icon-size: ${navigationMenuColumnStyle.arrowIconSize};
  }
`
